import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

const usePageTracking = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;

    // Fire and forget
    api.post('/activity/track', { page: path, action: 'page_view' }).catch(() => {});
  }, [location.pathname]);
};

export default usePageTracking;
